<template>
    <div>
        <div id="modal-template">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <h4 class="text-primary"><i class="fas fa-user btn-icon-wrapper btn-icon-sm"></i> Seleccionar Persona</h4>
                    </div>
                    <div class="modal-body">
                        <DataList url="/personas" :fields="fields" :rowClick="selectPersona" :institucion="true" :modal="true"></DataList>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="cerrarModal" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DataList from "@/components/layouts/DataList";
export default {
    name:'ModalSeleccionarPersona',
    components: {
        DataList,
    },
      data() {
        return {
        fields: [
            {
            name: "nombre",
            label: "Nombre",
            type: "title",
            class: "text-success",
            },
            {
            name: "apellido",
            label: "Apellido",
            type: "title",
            class: "text-success",
            },
            {
            name: "domicilio",
            label: "Domicilio",
            type: "field",
            class: ""
            },            
            {
            name: "cuil",
            label: "CUIL",
            type: "field",
            class: ""
            },
        ],
        loading: false
        };
    },
    methods:{
        cerrarModal(){
            this.$emit('cerrarSelectPersona')
        },
        selectPersona(persona){
            this.$emit("selectPersona", persona);
        }
    },
}
</script>